import * as yup from 'yup'
import { Container, TextField } from '@mui/material'
import Dialog from 'components/dialog/dialog'
import type { DetailStateProps, ErrorProps } from 'modules/types'
import type { PartialEvBrandCreateProps } from 'modules/partial'
import FORMIK from 'modules/formik'
import Notification from 'components/notification'
import GLOBAL from 'modules/global'
import DialogStyle from 'components/dialog/style'
import { useCreateEvBrandMutation } from 'store/evBrand'

const Create = ({ open, onClose }: DetailStateProps) => {
  if (!open) return <></>

  const [createEvBrand, create] = useCreateEvBrandMutation()

  const scheme = yup.object<PartialEvBrandCreateProps>({
    name: yup.string().required('Name is required')
  })

  const initialValues: PartialEvBrandCreateProps = {
    name: ''
  }

  const formik = FORMIK.useFormFormik<PartialEvBrandCreateProps>(scheme, initialValues, (values) =>
    createEvBrand(values)
  )

  const errorData = formik.errors

  return (
    <>
      <Dialog
        title='Create New EV Car Brand'
        open={open}
        onCancel={onClose}
        onSubmit={() => formik.handleSubmit()}
        loading={create.isLoading}
        isDisabled={!formik.isValid}
      >
        <Container {...DialogStyle.Container}>
          <TextField
            id='name'
            variant='outlined'
            label='Car Brand Name'
            value={formik.values.name}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={formik.touched && formik.touched.name && Boolean(errorData.name)}
            helperText={formik.touched && formik.touched.name && errorData && errorData.name}
            fullWidth
          />
        </Container>
      </Dialog>

      <Notification
        open={!create.isLoading && !create.isUninitialized}
        onClose={() => (create.isError ? create.reset() : location.reload())}
        isError={Boolean(create.error) && create.isError}
        message={GLOBAL.returnExceptionMessage(create.isError, create.error as ErrorProps)}
      />
    </>
  )
}

export default Create
